import type { ProductAction, ProductAttempt } from "@shared/analytics/productEvents";

import type { VerificationObserver } from "./enrollment";

const verificationActions: ReadonlySet<string> = new Set<ProductAction>([
    "verification_method_selected",
    "verification_consent_viewed",
    "verification_consent_accepted",
    "verification_consent_rejected",
    "verification_started",
    "proof_received",
    "verification_failed",
    "verification_resumed",
    "transfer_started",
    "transfer_submitted",
    "transfer_failed",
    "transfer_confirmation_deferred"
]);

/** The shared verifier reports observations; the calling product flow owns their names. */
export function observeSettingsVerification(attempt: ProductAttempt): VerificationObserver {
    return (event, properties = {}): void => {
        const action = event.split(":")[1];
        if (!verificationActions.has(action)) return;
        attempt.send(action as ProductAction, {
            verification_method: properties.verification_method,
            method: properties.method,
            proof_source: properties.proof_source,
            fallback_triggered: properties.fallback_triggered,
            transfer_available: properties.transfer_available,
            error_code: properties.error_code
        });
    };
}
